<template>
  <div class="uk-inline LangSwitcher">
    <button type="button" class="LangSwitcherBtn" :uk-tooltip="`title: ${crrFullLocaleName}; pos: left`">
      <img :src="`${ASSETS_BASE_URL}/images/lang/${crrLocale}.svg`" class="Icon"/>
    </button>
    <div uk-dropdown="mode: click">
      <ul class="uk-nav uk-dropdown-nav">
        <li v-for="(item, index) in locales" :key="index">
          <a v-if="item.code !== crrLocale" href="#" @click="(e) => changeLocale(item, e)">
            <img :src="`${ASSETS_BASE_URL}/images/lang/${item.code}.svg`" class="Icon"/>&nbsp;&nbsp;{{item.title}}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from '../store'
import types from '../store/types'

export default {
  name: 'LangSwitcherComponent',
  data: function () {
    return {
      locales: [
        { title: 'English', code: 'en' },
        { title: 'French', code: 'fr' },
        { title: 'German', code: 'de' },
        { title: 'Russian', code: 'ru' },
        { title: 'Portuguese', code: 'pt' },
        { title: 'Chinese', code: 'zh' }
      ]
    }
  },
  computed: {
    crrLocale: function () {
      return store.state.appSettings.locale
    },
    crrFullLocaleName: function () {
      const locale = this.locales.find(item => {
        if (item.code === store.state.appSettings.locale) {
          return item
        }
      })
      return locale ? locale.title : ''
    }
  },
  methods: {
    changeLocale: function (locale, event) {
      event.preventDefault()
      store.dispatch({
        type: types.changeLocale,
        locale: locale.code
      })
    }
  }
}
</script>

<style scoped>
  .LangSwitcher {
    position: fixed;
    top: 13px;
    right: 15px;
    z-index: 1000;
  }

  @media only screen and (max-width: 1300px) {
    .LangSwitcher {
      top: 95px;
    }
  }

  @media only screen and (max-width: 471px) {
    .LangSwitcher {
      top: 23px;
    }
  }

  .LangSwitcherBtn {
    background: #FFF;
    border: 0;
    padding: 2px;
    border-radius: 20px;
    box-shadow: 0 0 10px -3px #000;
    cursor: pointer;
  }

  .Icon {
    width: 32px;
  }
</style>
